import { useCallback, useEffect, useState } from "react";
import { zoomEfetivo } from "../../../../utils/zoomEfetivo";

type ReferenciaMedida = (no: HTMLElement | null) => void;

export interface AlturaDisponivel {
  referencia: ReferenciaMedida;
  altura: number;
}

const folgaDosAncestrais = (elemento: HTMLElement) => {
  let total = 0;
  let atual: HTMLElement | null = elemento;
  while (atual && atual !== document.body) {
    const estiloAtual = window.getComputedStyle(atual);
    total += parseFloat(estiloAtual.marginBottom) || 0;
    const pai: HTMLElement | null = atual.parentElement;
    if (pai && pai !== document.body) {
      const estiloPai = window.getComputedStyle(pai);
      total += parseFloat(estiloPai.paddingBottom) || 0;
      total += parseFloat(estiloPai.borderBottomWidth) || 0;
    }
    atual = pai;
  }
  return total;
};

export const useAlturaDisponivel = (folga = 8): AlturaDisponivel => {
  const [elemento, setElemento] = useState<HTMLElement | null>(null);
  const [altura, setAltura] = useState(0);

  const referencia = useCallback((no: HTMLElement | null) => setElemento(no), []);

  useEffect(() => {
    if (!elemento) {
      return undefined;
    }
    let quadro = 0;
    const medir = () => {
      quadro = 0;
      const area = elemento.getBoundingClientRect();
      const nova = Math.max(0, (window.innerHeight - area.top) / zoomEfetivo(elemento) - folgaDosAncestrais(elemento) - folga);
      setAltura((atual) => (Math.abs(nova - atual) < 1 ? atual : nova));
    };
    const agendar = () => {
      if (!quadro) {
        quadro = window.requestAnimationFrame(medir);
      }
    };
    medir();
    window.addEventListener("resize", agendar);

    const Observador = (window as any).ResizeObserver;
    const observador = typeof Observador === "function" ? new Observador(agendar) : null;
    if (observador) {
      observador.observe(document.body);
    }

    return () => {
      if (quadro) {
        window.cancelAnimationFrame(quadro);
      }
      window.removeEventListener("resize", agendar);
      if (observador) {
        observador.disconnect();
      }
    };
  }, [elemento, folga]);

  return { referencia, altura };
};

export default useAlturaDisponivel;
